module.exports = __webpack_public_path__ + "img/home-4.bc1ad1fa.webp";